import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavbarUtente from "./Navbar";
import Footer, { infoUtente, loadFooter } from "./Footer";
import Input from "../../components/Input";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import jsQR from "jsqr";
import Alert from "../../components/Alert";
import Loader from "../../components/Loader.jsx";
import Button from "../../components/Button.jsx";
import { Camera, Images, Wrench, PencilRuler, RefreshCw, ScanLine, MoveLeft } from "lucide-react";

const Articolo = () => {
    const [isFotoVisible, setIsFotoVisible] = useState(false);
    const [isCameraVisible, setIsCameraVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [stati, setStati] = useState([]);
    const navigate = useNavigate();
    const [isScanned, setIsScanned] = useState(true);
    const [data, setData] = useState({});
    const [id, setId] = useState(null);
    const [scanning, setScanning] = useState(false);
    const [selectedStato, setSelectedStato] = useState("");
    const [descrizioneManut, setDescrizioneManut] = useState("");
    const [isTakingPhoto, setIsTakingPhoto] = useState(false);
    const [facingEnv, setFacingEnv] = useState(true);
    const [descrizioneFoto, setDescrizioneFoto] = useState("");
    const canvasScan = useRef(null);
    const streamRef = useRef(null);
    const canvasCamera = useRef(null);
    const [filterFoto, setFilterFoto] = useState("");
    const [dataFoto, setDataFoto] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [isImgVisible, setIsImgVisible] = useState(false);
    const [img, setImg] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(
            filterFoto === ""
                ? dataFoto
                : dataFoto.filter((x) => {
                    const st = filterFoto.toLowerCase();
                    return (
                        x["PathFoto"].split("/").pop().toLowerCase().includes(st) ||
                        x["Descrizione"].toLowerCase().includes(st) ||
                        x["Timestamp"].toLowerCase().includes(st) ||
                        x["NomeUtente"].toLowerCase().includes(st) ||
                        x["CognomeUtente"].toLowerCase().includes(st)
                    );
                })
        );
    }, [filterFoto, dataFoto]);

    useEffect(() => {
        if (isFotoVisible) {
            const getFoto = async () => {
                try {
                    const r1 = await fetch('/getFotos', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente.CodiceDominio,
                            IDComponente: id
                        }),
                    });

                    const rd1 = await r1.json();

                    if (r1.status !== 200) {
                        console.error(rd1.error);
                        setAlertInfo({ type: "error", text: rd1.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setDataFoto([]);
                        setIsFotoVisible(false);
                    }
                    else {
                        setDataFoto(rd1);
                    }
                } catch (error) {
                    console.log(error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento delle foto. Riprova più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setDataFoto([]);
                    setIsFotoVisible(false);
                };
            }

            getFoto();
        }
    }, [isFotoVisible]);

    useEffect(() => {
        if (isCameraVisible) {
            handleStartCamera();
        }
    }, [isCameraVisible]);

    const onload = async () => {
        setIsLoading(true);
        try {

            await loadFooter();

            const r3 = await fetch('/getStati', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd3 = await r3.json();
            // console.log(rd3);
            if (r3.status === 500) {
                console.error(rd3.error);
                setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setStati(rd3.filter((d) => d["Obsoleto"] === false));

                if (document.cookie.split("IDComponente=").length > 1) {
                    setIsScanned(false);
                    scanSuccess(document.cookie.split("IDComponente=")[1].split(";")[0]);
                    document.cookie = "IDComponente=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                }
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina. Riprova più tardi.", onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const scanSuccess = async (qrCode) => {
        setIsLoading(true);
        try {
            const r1 = await fetch('/getComponente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    ID: qrCode
                })
            });
            const rd1 = await r1.json();

            if (r1.status !== 200) {
                console.error(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
                return;
            } else {
                if (rd1.length === 0) {
                    setAlertInfo({ type: "error", text: "Non è stato trovato nessun articolo collegato al codice scansionato", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                const r2 = await fetch('/getGestioneUtente', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDUtente: infoUtente.ID
                    })
                });

                const rd2 = await r2.json();

                if (r2.status === 500) {
                    console.error(rd2.error);
                    setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                else {
                    if (rd2[0]["IDAzienda"] === null) {
                        setId(rd1[0]["ID"]);
                        setData(rd1[0]);
                    }
                    else {
                        if (rd2.filter((d) => d["IDAzienda"] === rd1[0]["IDAzienda"]).length === 0) {
                            setAlertInfo({ type: "error", text: "Non hai i permessi per eseguire operazioni su questo componente", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                            setShowAlert(true);
                        }
                        else {
                            setId(rd1[0]["ID"]);
                            setData(rd1[0]);
                        }
                    }
                }
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dell'articolo. Riprova più tardi.", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleManutenzione = async () => {
        if (selectedStato === "") {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch('/addManutenzione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    EmailUtente: infoUtente.Email,
                    IDAzienda: data["IDAzienda"],
                    IDComponente: data["ID"],
                    Descrizione: descrizioneManut,
                    StatoAssunto: stati.find(s => s.ID === selectedStato)?.Nome || null
                })
            });

            if (response.status === 500) {
                const responseData = await response.json();
                console.error(responseData.error);
                setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setAlertInfo({ type: "success", text: "Manutenzione eseguita con successo", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore durante la manutenzione", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    // const handleOperazione = async () => {
    //     if (descrizioneManut === "") {
    //         alert("Inserire una descrizione");
    //         return;
    //     }
    //     if (selectedStato === "") {
    //         alert("Selezionare un'operazione");
    //         return;
    //     }
    //     try {
    //         const response = await fetch('/addOperazioneUser', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 CodiceDominio: infoUtente.CodiceDominio,
    //                 EmailUtente: infoUtente.Email,
    //                 IDAzienda: data["IDAzienda"],
    //                 IDComponente: data["ID"],
    //                 Descrizione: descrizioneManut,
    //                 IDOPerazione: Number(selectedStato)
    //             })
    //         });

    //         if (response.status === 500) {
    //             const responseData = await response.json();
    //             console.error(responseData.error);
    //             alert(responseData.error);
    //             window.location.reload();
    //         }
    //         else {
    //             navigate('/utente/dash');
    //         }
    //     } catch (error) {
    //         alert("Errore durante la manutenzione");
    //         console.log(error);
    //         window.location.reload();
    //     }
    //     setIsLoading(false);
    // };

    const handleStartScan = async () => {
        const newScanning = !scanning;
        setScanning(newScanning);
        if (newScanning) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: 'environment' }
                    }
                });
                streamRef.current = stream;
                const video = document.querySelector('video#scan');
                video.srcObject = stream;
                video.onloadedmetadata = () => {
                    video.play().then(() => {
                        video.removeAttribute('hidden');
                        setScanning(true);
                        setId(null);
                        requestAnimationFrame(detectQRCode);
                    }).catch(err => {
                        console.error("Errore avvio riproduzione:", err);
                    });
                };
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'accesso alla fotocamera. Riprova più tardi.", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } else {
            handleStopScan();
        }
    };

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasScan.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                    scanSuccess(code.data);
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
            window.location.reload();
        }
    };

    const handleStopScan = () => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }
        const video = document.querySelector('video#scan');
        const stream = video?.srcObject;
        try {
            const tracks = stream?.getTracks();

            tracks?.forEach(function (track) {
                track.stop();
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleStartCamera = async () => {
        const newTakingPhoto = !isTakingPhoto;
        setIsTakingPhoto(newTakingPhoto);
        if (newTakingPhoto) {
            try {
                setFacingEnv(true);
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: 'environment' }
                    }
                });
                const video = document.querySelector('video#camera');
                video.srcObject = stream;
                video.onloadedmetadata = () => {
                    video.play().then(() => {
                        video.removeAttribute('hidden');
                    }).catch(err => {
                        console.error("Errore avvio riproduzione:", err);
                    });
                };
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'accesso alla fotocamera. Riprova più tardi.", onClose: () => { setShowAlert(false); setIsCameraVisible(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } else {
            handleStopCamera();
        }
    };

    const handleStopCamera = () => {
        const video = document.querySelector('video#camera');
        const stream = video.srcObject;
        try {
            const tracks = stream.getTracks();
            tracks.forEach(function (track) {
                track.stop();
            });
            setIsTakingPhoto(false);
        } catch (error) {
            console.log(error);
            window.location.reload();
        }
    };

    const switchCamera = async () => {
        const video = document.querySelector('video#camera');
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        const newFacingEnv = !facingEnv;
        setFacingEnv(newFacingEnv);
        try {
            const newStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: newFacingEnv ? { ideal: 'environment' } : { ideal: 'user' }
                }
            });
            video.srcObject = newStream;
            video.onloadedmetadata = () => {
                video.play().then(() => {
                    video.removeAttribute('hidden');
                }).catch(err => {
                    console.error("Errore avvio riproduzione:", err);
                });
            };
        }
        catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'accesso alla fotocamera. Riprova più tardi.", onClose: () => { setShowAlert(false); setIsCameraVisible(false); }, needConfirm: false });
            setShowAlert(true);
        }
    };

    const dataURLToBlob = (dataURL) => {
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    const takePhoto = async () => {
        if (!canvasCamera.current) return;
        try {
            const video = document.querySelector('video#camera');
            const canvas = canvasCamera.current;
            const context = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            const img = canvas.toDataURL("image/jpeg");

            const formData = new FormData();
            const blob = dataURLToBlob(img);
            formData.append("image", blob);
            formData.append("CodiceDominio", infoUtente.CodiceDominio);
            formData.append("IDComponente", data["ID"]);
            formData.append("Descrizione", descrizioneFoto);
            formData.append("NomeUtente", infoUtente.Nome);
            formData.append("CognomeUtente", infoUtente.Cognome);
            const timestamp = new Date().toISOString().replace('T', ' ').replace(/\..+/, '');
            formData.append("Timestamp", timestamp);

            const r = await fetch("/addFoto", {
                method: "POST",
                body: formData,
            });

            if (r.status !== 200) {
                const rd = await r.json();
                console.error(rd.error);
                alert(rd.error);
            }
            else {
                setAlertInfo({ type: "success", text: "Immagine caricata con successo", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
                setDescrizioneFoto("");
            }
        } catch (error) {
            console.error("Errore nell'upload dell'immagine:", error);
            setAlertInfo({ type: "error", text: "Errore durante l'upload dell'immagine: " + error, onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
    };

    const handleFotoClick = async (path) => {
        try {
            const r = await fetch('/getImage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PathFoto: path,
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                console.error(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                setImg(url);
                setIsImgVisible(true);
            }
        }
        catch (error) {
            console.error("Errore nel caricamento dell'immagine:", error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dell'immagine: " + error, onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
    };

    return (
        <div className="h-[100svh]">
            <NavbarUtente page={isScanned ? "SCAN QR" : "ARTICOLO"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4 pb-24 flex flex-col justify-center items-center">
                {
                    id ? (
                        <>
                            {id && isScanned ? (
                                <Button type="full" classes="w-full mt-2" onClick={() => { setId(null); setIsScanned(true); handleStartScan(); }}>
                                    SCANSIONA DI NUOVO <ScanLine size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            ) : (
                                <div className="flex items-center justify-between w-full mt-2">
                                    <div className="flex items-center hover:cursor-pointer text-blue-600" onClick={() => navigate('/utente/cliente')}>
                                        <MoveLeft size={16} strokeWidth={2} className="inline-block mr-1" /> TORNA INDIETRO
                                    </div>
                                </div>
                            )}
                            <div className="flex justify-center my-2 rounded-lg bg-gray-200 dark:bg-neutral-800 py-2 w-full">
                                <div className="w-[90%] md:w-[50%]">
                                    <p className="flex justify-between">
                                        Nome :
                                        <span className="font-semibold">{data.Codice}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Descrizione :
                                        <span className="font-semibold">{data.Descrizione}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Sito :
                                        <span className="font-semibold">{data.Impianto}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Categoria :
                                        <span className="font-semibold">{data.Categoria}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Data di installazione :
                                        <span className="font-semibold">{data.DataInstallazione}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Data ultima manutenzione :
                                        <span className="font-semibold">{data.DataUltimaOperazione}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Stato :
                                        <span className="font-semibold" style={data.ColoreStato && { color: data.ColoreStato }}>{data.StatoAttuale}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Prossima manutenzione :
                                        <span className="font-semibold">{data.ProssimaManutenzione}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2 mt-4 w-full">
                                <Button type="hollow" onClick={() => setIsCameraVisible(true)}>
                                    SCATTA FOTO <Camera size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type="hollow" onClick={() => setIsFotoVisible(true)}>
                                    GALLERIA FOTO <Images size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            </div>
                            <div className="flex justify-center items-center mt-4">MANUTENZIONE</div>
                            <Input
                                label="Descrizione"
                                value={descrizioneManut}
                                setValue={setDescrizioneManut}
                                type="text"
                                classes="mt-2 w-full"
                                disabled={false}
                                error={false}
                            />
                            <div className="grid grid-cols-2 gap-2 items-center w-full">
                                <Combobox
                                    key={stati.length} // Aggiungi questa linea per forzare il rerender del componente Combobox
                                    options={stati.map((d) => ({ label: d.Nome, value: d.ID }))}
                                    onChange={setSelectedStato}
                                    label="Stato assunto *"
                                    classes="mt-2 w-full"
                                    disabled={false}
                                    error={false}
                                    readOnly={false}
                                    defaultValue={selectedStato}
                                />
                                <div className="flex justify-between mt-2">
                                    <span>Colore:</span>
                                    <span className="w-[70%] rounded-md" style={{ backgroundColor: stati.find(s => s.ID === selectedStato)?.Colore }}></span>
                                </div>
                            </div>
                            <Button type="full" onClick={handleManutenzione} classes="mt-2">
                                ESEGUI MANUTENZIONE <Wrench size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button type="hollow" classes="w-full mt-2" onClick={handleStartScan}>
                                SCANSIONA CODICE <ScanLine size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                            {
                                scanning && (
                                    <div className="flex justify-center items-center text-black dark:text-white mt-4">
                                        <video muted autoPlay playsInline hidden width="70%" height="70%" id="scan" className="rounded"></video>
                                        <canvas
                                            ref={canvasScan}
                                            style={{ display: 'none' }}
                                            hidden
                                        />
                                    </div>
                                )
                            }
                        </>
                    )
                }
                <PopUp title={"Fotocamera"}
                    isVisible={isCameraVisible}
                    setIsVisible={() => { setIsCameraVisible(false); handleStartCamera(); }}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center">
                        <div className="w-[90%]">
                            <Input
                                label="Descrizione foto"
                                value={descrizioneFoto}
                                setValue={setDescrizioneFoto}
                                type="text"
                                classes="my-2 w-full"
                                disabled={false}
                                error={false}
                            />
                            <video muted autoPlay playsInline hidden width="100%" height="70%" id="camera" className="rounded justify-self-center"></video>
                            <canvas
                                ref={canvasCamera}
                                style={{ display: 'none' }}
                                hidden
                            />
                            <div className="grid grid-cols-3 gap-2 mt-2">
                                <div></div>
                                <div className="flex justify-center items-center">
                                    <button
                                        className="flex justify-start items-center text-blue-600 rounded-full bg-gray-200 dark:bg-neutral-800 p-4"
                                        onClick={takePhoto}
                                    >
                                        <Camera size={60} />
                                    </button>
                                </div>
                                <div className="flex justify-center items-center">
                                    <button
                                        className="flex justify-start items-center text-blue-600 rounded-full bg-gray-200 dark:bg-neutral-800 p-2"
                                        onClick={switchCamera}
                                    >
                                        <RefreshCw size={40} className="rotate-45" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </PopUp>
                <PopUp title={"Foto"}
                    isVisible={isFotoVisible}
                    setIsVisible={setIsFotoVisible}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center">
                        <div className="w-[90%]">
                            <Input
                                label="Filtra foto..."
                                value={filterFoto}
                                setValue={setFilterFoto}
                                type="text"
                                classes="mb-2 w-full"
                                disabled={false}
                                error={false}
                            />
                            {
                                viewData.length > 0 ? (
                                    viewData.map((elem, index) => (
                                        <>
                                            <div
                                                className="grid grid-cols-2 p-2 rounded bg-gray-200 dark:bg-neutral-800 hover:bg-gray-300 dark:hover:bg-neutral-700 hover:cursor-pointer my-2"
                                                onClick={() => handleFotoClick(elem["PathFoto"])}
                                            >
                                                <span className="self-center font-bold">{elem["PathFoto"].split("/").pop()}</span>
                                                <span className="self-center text-right">{elem["Timestamp"]}</span>
                                                <span className="self-center">{elem["Descrizione"]}</span>
                                                <span className="self-center text-right italic">{`${elem["CognomeUtente"]} ${elem["NomeUtente"]}`}</span>
                                            </div>
                                            {
                                                isImgVisible && img && (
                                                    <div
                                                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back"
                                                        onClick={() => setIsImgVisible(false)}
                                                    >
                                                        <div className="p-4 rounded-lg" style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                                                            <img
                                                                src={img}
                                                                alt="Preview"
                                                                className="max-w-full max-h-[80vh] mx-auto block rounded-md"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </>
                                    ))
                                ) : (
                                    <p className="text-center">Nessuna foto trovata.</p>
                                )
                            }
                        </div>
                    </div>
                </PopUp>
            </div>
            <Footer />
        </div>
    )
};

export default Articolo;